<template>
    <div>
        <el-dialog :title="dialogTitle" :visible.sync="visible" width="80%" class="BorderRadius" :before-close="CloseDig"
            top="5vh">
            <div class="MaxHei">
                <template v-if="Type == 'PS'">
                    <div v-if="localRowData.score_rule && Sys!='fund'">
                        <div class="PSTit">形式审查建议</div>
                        <el-table :data="localRowData.score_rule" border stripe style="width: 100%;" class="custom-header-table">
                            <el-table-column prop="indicator" label="评价指标" min-width="100"></el-table-column>
                            <el-table-column prop="description" label="描述" min-width="200"></el-table-column>
                            <el-table-column prop="gl_yj" label="审查建议" min-width="200"></el-table-column>
                        </el-table>
                    </div>
                    <div v-if="localRowData.Online">
                        <div class="PSTit DisFlex">
                            <span>{{Sys!='fund'?'资料':'初审'}}情况</span>
                            <el-button v-if="Admin&&(localRowData.sq_status==3||localRowData.sq_status==4)" v-throttle class="BgColor" size="small" type="primary" @click="ToggleUser(localRowData.Online,1)">添加专家</el-button>
                        </div>
                        <el-table :data="localRowData.Online" border stripe style="width: 100%;" class="custom-header-table">
                            <el-table-column prop="user_name" label="评审专家" min-width="50"></el-table-column>
                            <el-table-column prop="identity_name" label="专家类型" min-width="50"></el-table-column>
                            <el-table-column prop="pingfen" label="评审总分" min-width="50"></el-table-column>
                            <el-table-column prop="pingjunfen" label="每项平均分" min-width="60" v-if="Sys!='fund'"></el-table-column>
                            <el-table-column label="评审项分数未满" min-width="150" v-if="Sys!='fund'">
                                <template slot-scope="scope">
                                    <div v-for="item in scope.row.rule" :key="item.id" v-if="item.rating!=item.score && item.opinion">
                                        <span>{{item.indicator}}：{{item.opinion}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="opinion" label="最终评审意见" min-width="150"></el-table-column>
                            <el-table-column prop="zz_zj" label="总结" min-width="100" v-if="Sys!='fund'"></el-table-column>
                            <!-- <el-table-column prop="qm_url" label="签名" min-width="50">
                                <template slot-scope="scope">
                                    <el-image v-if="scope.row.qm_url" @click="LockUrl(scope.row.qm_url)" style="width: 50px; height: 50px" :src="$Tools.ServeUrl()+scope.row.qm_url" fit="contain"></el-image>
                                </template>
                            </el-table-column> -->
                            <el-table-column prop="pf_time" label="评审时间" min-width="100"></el-table-column>
                            <el-table-column label="操作" min-width="50" v-if="Admin&&(localRowData.sq_status==3||localRowData.sq_status==4)">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.identity!=1" v-throttle class="BgColor" size="small" type="danger" @click="RemoveUser(scope.row,1)">删除此专家</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="localRowData.Final">
                        <div class="PSTit DisFlex">
                            <span>{{Sys!='fund'?'现场':'复审'}}情况</span>
                            <el-button v-if="Admin&&(localRowData.sq_status==6||localRowData.sq_status==7)" v-throttle class="BgColor" size="small" type="primary" @click="ToggleUser(localRowData.Final,2)">添加专家</el-button>
                        </div>
                        <el-table :data="localRowData.Final" border stripe style="width: 100%;" class="custom-header-table">
                            <el-table-column prop="user_name" label="评审专家" min-width="50"></el-table-column>
                            <el-table-column prop="identity_name" label="专家类型" min-width="50"></el-table-column>
                            <el-table-column prop="pingfen" label="总评分" min-width="50"></el-table-column>
                            <el-table-column prop="pingjunfen" label="每项平均分" min-width="60" v-if="Sys!='fund'"></el-table-column>
                            <el-table-column label="评审项分数未满" min-width="150" v-if="Sys!='fund'">
                                <template slot-scope="scope">
                                    <div v-for="item in scope.row.rule" :key="item.id" v-if="item.rating!=item.score && item.opinion">
                                        <span>{{item.indicator}}：{{item.opinion}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="opinion" label="最终评审意见" min-width="150"></el-table-column>
                            <el-table-column prop="zz_zj" label="总结" min-width="100" v-if="Sys!='fund'"></el-table-column>
                            <!-- <el-table-column prop="qm_url" label="签名" min-width="50">
                                <template slot-scope="scope">
                                    <el-image v-if="scope.row.qm_url" @click="LockUrl(scope.row.qm_url)" style="width: 50px; height: 50px" :src="$Tools.ServeUrl()+scope.row.qm_url" fit="contain"></el-image>
                                </template>
                            </el-table-column> -->
                            <el-table-column prop="pf_time" label="评审时间" min-width="100"></el-table-column>
                            <el-table-column label="操作" min-width="50" v-if="Admin&&(localRowData.sq_status==6||localRowData.sq_status==7)">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.identity!=1" v-throttle class="BgColor" size="small" type="danger" @click="RemoveUser(scope.row,2)">删除此专家</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="localRowData.dianping">
                        <div class="PSTit DisFlex">
                            <span>点评情况</span>
                            <el-button v-if="Admin&&(localRowData.sq_status==9||localRowData.sq_status==10)" v-throttle class="BgColor" size="small" type="primary" @click="ToggleUser(localRowData.dianping,'')">添加专家</el-button>
                        </div>
                        <el-table :data="localRowData.dianping" border stripe style="width: 100%;" class="custom-header-table">
                            <el-table-column prop="user_name" label="点评专家" min-width="50"></el-table-column>
                            <el-table-column prop="dianping" label="点评意见" min-width="300"></el-table-column>
                            <el-table-column prop="dianping_url" label="附件" min-width="100">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.dianping_url" type="success" @click="LockUrl(scope.row.dianping_url)">附件</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="dianping_time" label="点评时间" min-width="100"></el-table-column>
                            <el-table-column label="操作" min-width="50" v-if="Admin&&(localRowData.sq_status==9||localRowData.sq_status==10)">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.identity!=1" v-throttle class="BgColor" size="small" type="danger" @click="RemoveUser(scope.row,3)">删除此专家</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </template>
                <template v-if="Type == 'PF'">
                    <div v-if="localRowData.Online">
                        <div v-for="item in localRowData.Online" :key="item.id">
                            <div class="PSTit">
                                资料评分<el-tag type="info">{{item.user_name}}</el-tag>
                                平均分：<el-tag type="success">{{item.pingjunfen}}</el-tag>
                                类型： <el-tag>{{item.identity?'组长':'组员'}}</el-tag>
                            </div>
                            <el-table :data="item.rule" border stripe style="width: 100%;" class="custom-header-table">
                                <el-table-column prop="indicator" label="评价指标" min-width="100"></el-table-column>
                                <el-table-column prop="description" label="指标描述" min-width="200"></el-table-column>
                                <!-- <el-table-column prop="weight" label="权重" min-width="50"></el-table-column> -->
                                <el-table-column prop="score" label="满分" min-width="50"></el-table-column>
                                <el-table-column prop="rating" label="打分" min-width="50"></el-table-column>
                                <el-table-column prop="opinion" label="备注" min-width="80"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div v-if="localRowData.Final">
                        <div v-for="item in localRowData.Final" :key="item.id">
                            <div class="PSTit">
                                现场评分<el-tag type="info">{{item.user_name}}</el-tag>
                                平均分：<el-tag type="success">{{item.pingjunfen}}</el-tag>
                                类型： <el-tag>{{item.identity?'组长':'组员'}}</el-tag>
                            </div>
                            <el-table :data="item.rule" border stripe style="width: 100%;" class="custom-header-table">
                                <el-table-column prop="indicator" label="评价指标" min-width="100"></el-table-column>
                                <el-table-column prop="description" label="指标描述" min-width="200"></el-table-column>
                                <!-- <el-table-column prop="weight" label="权重" min-width="50"></el-table-column> -->
                                <el-table-column prop="score" label="满分" min-width="50"></el-table-column>
                                <el-table-column prop="rating" label="打分" min-width="50"></el-table-column>
                                <el-table-column prop="opinion" label="备注" min-width="80"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </template>
            </div>
        </el-dialog>
        <el-dialog title="给本组增加评审专家" :visible.sync="ExpertData.blon" width="40%" class="BorderRadius" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="DigItem">
                <div class="DigItemTit">点评专家：</div>
                <el-select class="Wid" size="medium" v-model="ExpertData.id" clearable filterable  placeholder="请选择专家">
                    <el-option v-for="item in ExpertUser" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">是否组长：</div>
                <el-radio-group v-model="ExpertData.is_zz">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(ExpertData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="DianPingSuc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "RecordDialog",
        props: {
            // 弹窗显隐状态 (父组件传值)
            visible: {
                type: Boolean,
                default: false,
            },
            // 表单详情数据 包含group和gl_file
            rowData: {
                type: Object,
                default: () => ({
                    Final: [],       
                    Online: [],     
                    score_rule: [],  
                    sq_status: 0    
                }),
            },
            Type: {
                type: String,
                default: "PS",
                validator: (val) => ["PS", "DB", "PF"].includes(val),
            },
        },
        data() {
            return{
                Admin:this.$Tools.localData('g')==1?true:false,
                ExpertUser:[],
                ExpertData:{
                    id:"",
                    blon:false,
                    rowId:"",
                    type:"",
                    is_zz:0,
                },
                SystemList:JSON.parse(this.$Tools.localData("SystemMenu")),
                Sys:this.$Tools.localData("ApiType"),
                localRowData: {} // 本地数据副本，解决props修改问题
            }
        },
        watch: {
            rowData: {
                immediate: true, 
                handler(newVal) {
                    this.localRowData = JSON.parse(JSON.stringify(newVal));
                }
            }
        },
        computed: {
            // 根据Type自动计算弹窗标题，无需父组件传标题
            dialogTitle() {
                switch (this.Type) {
                    case "PS":
                        return "评审情况";
                    case "PF":
                        return "评分明细";
                    default:
                        return "";
                }
            },
        },
        methods: {
            GetData(id,t){
                var url = t==1?'/admin/online/gradeinfo':'/admin/final/gradeinfo';
                this.$get(url,{
                    id:id,
                }).then(res=>{
                    if(res){
                        this.localRowData = res.data;
                    }
                })
            },
            GetUserData(type){
                var sysId = this.SystemList.filter(item => item.system_code == this.Sys)[0].id;
                this.$get('/admin/expert/index',{
                    page_size:500,
                    system_id:sysId,
                    is_review:type,
                }).then(res=>{
                    if(res){
                        this.ExpertUser = res.data.list;
                        this.ExpertData.blon = true;
                    }
                })
            },
            ToggleUser(row,t){
                this.ExpertData.id="";
                this.GetUserData(t);
                this.ExpertData.rowId = row[0].record_id;
                this.ExpertData.type = t;
            },
            DianPingSuc(){
                var url = this.ExpertData.type==1?'/admin/online/zhuajiaadd':this.ExpertData.type==2?'/admin/final/zhuajiaadd':'/admin/dianping/zhuajiaadd';
                this.$get(url,{
                    user_id:this.ExpertData.id,
                    record_id:this.ExpertData.rowId,
                    is_zz:this.ExpertData.is_zz,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData(this.ExpertData.rowId,this.ExpertData.type)
                        this.$Tools.ResetData(this.ExpertData);
                    }
                })
            },
            RemoveUser(row,t){
                var url = t==1?'/admin/online/zhuanjiarevoke':t==2?'/admin/final/zhuanjiarevoke':'/admin/dianping/zhuanjiarevoke';
                this.$confirm('确认撤回专家吗?', '提示', {
                	type: 'warning'
                }).then(() => {
                    this.$get(url,{
                        record_user_id:row.id,
                        record_id:row.record_id,
                    }).then(res=>{
                        if(res){
                            this.$message.success(res.msg);
                            this.GetData(row.record_id,t)
                        }
                    })
                })
            },
            CloseDig() {
                this.$emit("cancel");
            },
            LockUrl(url){
                window.open(this.$Tools.ServeUrl()+url)
            },
        },
    };
</script>

<style scoped>
    .MaxHei {
        max-height: 600px;
        overflow-y: auto;
    }

    .PSTit {
        padding: 10px 0;
        font-size: 16px;
        font-weight: 700;
    }
    .DisFlex{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .FuJianPos{
        position: relative;
        padding: 6px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }
</style>